import type { ArticleItem } from '@/mocks/articles';

interface ArticleBodyProps {
  article: ArticleItem;
}

export default function ArticleBody({ article }: ArticleBodyProps) {
  return (
    <div className="mt-8">
      <figure className="mb-9">
        <div className="h-[240px] w-full overflow-hidden rounded-lg border border-background-200 md:h-[420px]">
          <img
            src={article.cover}
            alt={`${article.title} 相关配图 - 深夜爆料`}
            title={`${article.title} 深夜爆料 首发`}
            className="h-full w-full object-top"
          />
        </div>
        <figcaption className="mt-3 text-center text-xs text-foreground-600">
          配图为栏目氛围图，与线索细节无关 · 深夜爆料编辑组
        </figcaption>
      </figure>

      <div className="space-y-6">
        {article.content.map((paragraph, index) => (
          <p
            key={index}
            className={
              index === 0
                ? 'text-base leading-[1.9] text-foreground-200 md:text-lg md:leading-[2]'
                : 'text-sm leading-[1.95] text-foreground-300 md:text-base md:leading-[1.95]'
            }
          >
            {paragraph}
          </p>
        ))}
      </div>

      <div className="mt-10 rounded-lg border border-secondary-500/25 bg-secondary-500/5 p-5">
        <h2 className="flex items-center gap-2 font-heading text-sm font-semibold text-secondary-200">
          <i className="ri-shield-check-line"></i>
          信源与核实说明
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-foreground-500">
          本文信息已由编辑组完成至少两次独立交叉比对。涉及方若有不同说法，欢迎通过「联系我们」提交，我们会在核实后于原文顶部追加说明。为保护线索人，文中不披露可定位到个人的信息。
        </p>
      </div>

      <div className="mt-8 flex flex-wrap items-center gap-2">
        <span className="text-xs text-foreground-600">相关标签</span>
        {article.tags.map((tag) => (
          <span
            key={tag}
            className="rounded-full bg-background-200 px-3 py-1 text-xs text-foreground-300"
          >
            #{tag}
          </span>
        ))}
      </div>
    </div>
  );
}